import i18nService from '../../../services/i18nService';
import qtiConstants from '../../../qti/Constants';
import loadingTools from '../loadingTools';

const { CKEDITOR_LATEST, WEBSPELLCHECKER_WEB_LATEST } = qtiConstants.staticLibPaths;
const tag = '?t=I63C';

const CKEditorLoader = {
    getCoreFile() {
        return { url: `${CKEDITOR_LATEST}ckeditor.js` };
    },

    getExtraFiles() {
        const files = [
            { url: `${CKEDITOR_LATEST}skins/moono-lisa/images/close.png`, type: 'image' },
            { url: `${CKEDITOR_LATEST}skins/moono-lisa/icons.png?t=de1371d`, type: 'image' },
            { url: `${CKEDITOR_LATEST}skins/moono-lisa/dialog.css${tag}`, type: 'css' },
            { url: `${CKEDITOR_LATEST}skins/moono-lisa/editor.css${tag}`, type: 'css' },
            { url: `${CKEDITOR_LATEST}skins/moono-lisa/editor_gecko.css${tag}`, type: 'css' },
            { url: `${CKEDITOR_LATEST}plugins/wordcount/css/wordcount.css`, type: 'css' },
            { url: `${CKEDITOR_LATEST}plugins/table/dialogs/table.js${tag}`, type: 'js' },
            { url: `${CKEDITOR_LATEST}plugins/specialchar/dialogs/specialchar.js${tag}`, type: 'js' },
            { url: `${CKEDITOR_LATEST}plugins/a11yhelp/dialogs/a11yhelp.js${tag}`, type: 'js' },
            { url: `${CKEDITOR_LATEST}styles.js${tag}`, type: 'js' },
            { url: `${CKEDITOR_LATEST}plugins/magicline/images/icon.png?t=de1371d`, type: 'image' },
            { url: `${CKEDITOR_LATEST}contents.css${tag}`, type: 'css' },
        ];

        i18nService
            .getAvailableLanguages()
            .forEach((lang) => {
                const langCode = i18nService.getIetfLanguageCode(lang);
                const ckLang = i18nService.languageMapIetfToCKEditor[langCode];
                if (ckLang !== undefined) {
                    files.push({ url: `${CKEDITOR_LATEST}lang/${ckLang}.js${tag}`, type: 'js' });
                    files.push({ url: `${CKEDITOR_LATEST}plugins/specialchar/dialogs/lang/${ckLang}.js${tag}`, type: 'js' });
                    files.push({ url: `${CKEDITOR_LATEST}plugins/a11yhelp/dialogs/lang/${ckLang}.js${tag}`, type: 'js' });
                }
            });

        return files;
    },

    getAllFilesToCache(questions) {
        const files = [this.getCoreFile()];
        files.push(...this.getExtraFiles(questions));
        return files;
    },

    async init() {
        return loadingTools.loadLibrary(this.getCoreFile().url, 'CKEDITOR');
    },

    async loadSpellcheckerBundle() {
        if (!window.WEBSPELLCHECKER) {
            return loadingTools.loadLibrary(`${WEBSPELLCHECKER_WEB_LATEST}wscbundle/wscbundle.js`, 'WEBSPELLCHECKER');
        }
        return Promise.resolve(window.WEBSPELLCHECKER);
    },
};

export default CKEditorLoader;
